import {captureException, captureMessage} from '@sentry/react';

import {AppError, SENTRY_WHITELIST} from '../utils/errors';

export function handleError(
  e: unknown,
  onError?: (error: Error) => void
): void {
  if (!(e instanceof Error)) return;

  if (e instanceof AppError) {
    if (e.kind === 'critical') captureException(e);
  } else {
    const code = parseInt(e.name);
    if (!code || SENTRY_WHITELIST.includes(code)) {
      captureException(e);
    } else {
      captureMessage(`${e.name}: ${e.message}`, 'warning');
    }
  }

  console.error(e);

  onError?.(e);
}
